<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sd/ba"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
    >
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="商务编号">
              <el-input v-model.trim="filter.businessApplicationNO" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customer" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model.trim="filter.status" placeholder="请选择" clearable>
                <el-option label="草稿" value="2201"/>
                <el-option label="待审核" value="2202"/>
                <!--                <el-option label="财务经理审核" value="销售总监审核"/>-->
                <!--                <el-option label="总经理审批" value="总经理审批"/>-->
                <el-option label="通过" value="2203"/>
                <el-option label="驳回" value="2204"/>
              </el-select>
            </el-form-item>
            <el-form-item label="时间限制">
              <el-select v-model.trim="filter.timeLimit" placeholder="请选择" clearable>
                <el-option label="自定义期限" value="20"/>
                <el-option label="一次有效" value="10"/>
                <el-option label="永久有效" value="-1"/>
              </el-select>
            </el-form-item>
            <el-form-item label="业务员">
              <el-input v-model.trim="filter.salesPersonName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
            <el-form-item label="提交时间">
              <el-date-picker
                  v-model="submitTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitTimeRange', 'submitBeginDate', 'submitEndDate')"/>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker
                  v-model="startTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('startTimeRange', 'startTimeBegin', 'startTimeEnd')"/>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                  v-model="endTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('endTimeRange', 'endTimeBegin', 'endTimeEnd')"/>
            </el-form-item>
            <el-form-item label="通过日期">
              <el-date-picker
                  v-model="passTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('passTimeRange', 'passTimeBegin', 'passTimeEnd')"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :loading="submitLoading"
            :disabled="scope.row.status !== 2201 && scope.row.status!==2204"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button v-if="limits.passAuth" type="danger" :disabled="scope.row.status === 2203" @click="pass(scope.row)">通过</el-button>
        <el-button v-if="limits.rejectAuth" type="danger" :disabled="scope.row.status !== 2203" @click="reject(scope.row)">驳回</el-button>
      </template>
      <template slot="otherBtn">
<!--        <el-upload-->
<!--            action=""-->
<!--            v-if="limits.importAuth"-->
<!--            :http-request="importFile"-->
<!--            :show-file-list="false"-->
<!--            style="float: left; margin-right: 4px;">-->
<!--          <el-button type="primary" :loading="importLoading">导入模板</el-button>-->
<!--        </el-upload>-->
<!--        <el-button-->
<!--            type="primary"-->
<!--            plain-->
<!--            icon="el-icon-download"-->
<!--            @click="downloadModel">-->
<!--          模板下载-->
<!--        </el-button>-->
      </template>
    </view-table>
    <business-application-edit ref="businessApplicationEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import BusinessApplicationEdit from "./BusinessApplicationEdit";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "BusinessApplicationList",
    components: {ViewTable, BusinessApplicationEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(348),
          editAuth: this.$auth(349),
          delAuth: this.$auth(351),
          subAuth: this.$auth(350),
          passAuth: this.$auth(32),
          rejectAuth :this.$auth(33),
          importAuth :this.$auth(36),
        },
        importLoading: false,
        submitLoading: false,
        createTimeRange: [],
        submitTimeRange: [],
        startTimeRange: [],
        endTimeRange: [],
        passTimeRange: [],
        filter: {
          businessApplicationNO: "",
          customer: "",
          status: "",
          materialNo: "",
          materialName: "",
          specification: "",
          timeLimit: "",
          salesPersonName: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitBeginDate: "",
          submitEndDate: "",
          startTimeBegin: "",
          startTimeEnd: "",
          endTimeBegin: "",
          endTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "businessApplicationNO",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.businessApplicationEdit.open(params.row,false,false,false);
                    },
                  },
                },
                params.row.businessApplicationNO,
              );
            },
          },
          {
          tooltip: true,
            key: "customerName",
            width: 260,
          },
          {
          tooltip: true,
            key: "contact",
            align: "center",
            width: 90,
          },
          {
          tooltip: true,
            key: "mobile",
            align: "center",
            width: 140,
          },
          {
          tooltip: true,
            key: "statusName",
            width: 220,
          },
          {
          tooltip: true,
            key: "timeLimit",
            align: "center",
            width: 110,
            render: (h, params) => {
              if (params.row.timeLimit === 20) {
                return h("span", "自定义期限");
              } else if (params.row.timeLimit === 10) {
                return h("span", "一次有效");
              } else {
                return h("span", "永久有效");
              }
            },
          },
          {
          tooltip: true,
            key: "beginDate",
            align: "center",
            width: 160,
          },
          {
          tooltip: true,
            key: "endDate",
            align: "center",
            width: 160,
          },
          {
          tooltip: true,
            key: "paymentTypeName",
            width: 180,
          },
          {
          tooltip: true,
            key: "reason",
            width: 160,
            ellipsis: true,
          },
          {
          tooltip: true,
            key: "submitTime",
            align: "center",
            width: 160,
          },
          {
          tooltip: true,
            key: "creatorName",
            align: "center",
            width: 90,
          },
          {
          tooltip: true,
            key: "createdDate",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 300,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.businessApplicationEdit.open(row,false,false,true);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "sd/ba", row.businessApplicationID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // 提交
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `sd/ba/submit/${row.businessApplicationID}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            }
          }).finally(()=>{
            this.submitLoading = false;
            this.loadData();
          });
        });
        this.submitLoading = false;
        this.loadData();
      },

      // 复制(只能复制状态为通过的数据)
      copyHandle(row) {
        this.$refs.businessApplicationEdit.open(row, 1);
      },


      // 只能编辑和删除未提交的数据
      otherAuth(row) {
        if (row.status === 2201 || row.status === 2204) {
          return false;
        } else {
          return true;
        }
      },

      pass(row) {
        this.$http.get("basic",`sd/ba/getOaResult/${row.businessApplicationID}/1`)
          .finally(this.loadData);
      },

      reject(row) {
        this.$http.get("basic",`sd/ba/getOaResult/${row.businessApplicationID}/0`)
          .finally(this.loadData);
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "sd/ba/importFile", formData).then((res) => {
          if (res.success) {
            this.importLoading = false;
            this.loadData(1);
            this.$message.success(res.data);
          } else {
            this.importLoading = false;
            this.$message.error(res.data);
          }
        }).catch(() => {
          this.importLoading = false;
          this.$message.error("导入失败");
        });
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/客户特价模版.xlsx");
      },
    },
  };
</script>
